import { IndustryRoleType, DataType } from './AcpCellRolesIndustriesMultiselect.types'

export const setNewIndustryRole = (industryRoles: IndustryRoleType[], editedData: DataType[]) => {
  return editedData.map((newData: DataType) => {
    const existingIndustry = industryRoles.find(industry => newData.value === industry.industry_id)
    const roleIds = (newData?.options || []).map(opt => opt.value)
    return existingIndustry ? { ...existingIndustry, role_ids: roleIds } : { industry_id: newData.value, role_ids: roleIds }
  })
}
